<ng-container *ngIf="weatherStatus">
  <div
    class="me-4 pe-2 fs-12 border-right"
    title="Update at: {{ weatherStatus.Time }}"
    [ngStyle]="{'white-space': 'nowrap'}">
    <!-- Temperature -->
    <div class="d-inline-block text-center">
      <img
        src="./assets/images/icons/weather/{{ weatherStatus.Symbol_Code }}.svg"
        height="26px"
        alt=" ">
      <br>
      <span>
        {{ weatherStatus.Air_Temperature_Value | number : '1.0-0' }}&#8451;
      </span>
    </div>
    <!-- Precipitation Rate -->
    <div class="d-inline-block text-center me-2 ms-2">
      <span class="fs-18">
        <i class="fa fa-umbrella mb-1"></i>
      </span>
      <br>
      <span>
        {{ weatherStatus.Precipitation_Rate_Value | nullAsWhatever : 0 | number : '1.0-0' }}
        <small>
          {{ weatherStatus.Precipitation_Rate_Unit }}
        </small>
      </span>
    </div>
    <!-- Wind Direction -->
    <div class="d-inline-block text-center">
      <span class="fs-18">
        <i class="{{ getWindIconByDirection(windDirection) }} mb-1"></i>
      </span>
      <br>
      <span [ngStyle]="{'letter-spacing': '-0.5px'}">
        {{ windDirection }}
        {{ weatherStatus.Wind_Speed_Value | number : '1.0-0' }}
        ({{ weatherStatus.Wind_Speed_Of_Gust_Value | number : '1.0-0' }})
        <small>
          {{ weatherStatus.Wind_Speed_Unit }}
        </small>
      </span>
    </div>
  </div>
</ng-container>
